import { render, staticRenderFns } from "./app_header.vue?vue&type=template&id=36f220da&scoped=true&"
import script from "./app_header.vue?vue&type=script&lang=js&"
export * from "./app_header.vue?vue&type=script&lang=js&"
import style0 from "./app_header.vue?vue&type=style&index=0&id=36f220da&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f220da",
  null
  
)

export default component.exports